export const baseNameRouter = {
  server: basename => () => {
    const routerOptions = {
      basename
    };
    return Promise.resolve(routerOptions);
  },
  client: basename => () => {
    const routerOptions = {
      basename
    };
    return Promise.resolve(routerOptions);
  }
};